// @flow
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { injectGlobal } from 'styled-components';
import 'babel-polyfill';
import round10 from 'round10';

import styles from './assets/css/index';
import unregister from './registerServiceWorker';

import App from './App';
import store from './store';

injectGlobal`${styles}`;
round10.polyfill();

const root = document.getElementById('root');

if (root) {
	render(
		<Provider store={store}>
			<App />
		</Provider>,
		root,
	);

	unregister();
}


// WEBPACK FOOTER //
// ./src/index.js